import React from "react"
import { Link } from "gatsby"
import { Container } from "react-bootstrap"
import { AiOutlineRight } from "react-icons/ai"
import styled from "styled-components"

const StyledBreadcrumbsContainer = styled(Container)`
	position: relative;
	z-index: 9;

	.breadcrumbs {
		position: absolute;
		padding-top: 20px;
		padding-bottom: 20px;

		a {
			&:hover,
			&focus {
				color: #752163;
			}
		}

		span {
			font-size: 14px;
			text-transform: capitalize;
		}

		> * {
			padding-top: 5px;
			padding-bottom: 5px;
		}

		@media (min-width: 768px) {

			> * {
				display: inline-block;
			}
		}
	}
`

export default props => {
  // console.log(props.path)

  let acc = ""
  const crumbs = []
  props.path.substring(1, props.path.length).split("/").filter(Boolean).forEach(element => {
    let crumb = {
      title: element.replace(/-/g, " "),
      path: acc + "/" + element + "/",
    }
    crumbs.push(crumb)
    acc += "/" + element
  })

  const breadcrumbs = (
    crumbs.map((crumb, key) => {
      if (crumb.path !== props.path && crumb.path !== props.path + "/") {
        return <Link key={key} to={crumb.path}><span>{crumb.title}</span><AiOutlineRight
          size={".8em"} style={{
          margin: "0 0.3em",
          opacity: 0.5,
        }}/></Link>
      } else {
        return (
          <span key={key} style={{ opacity: 0.5 }}>
            <span className={`d-xl-none`}>
              {crumb.title.substring(0, 32)}
              {crumb.title.length > 32 ? "..." : ""}
            </span>
            <span className={`d-none d-xl-block`}>{crumb.title}</span>
          </span>
        )
      }
    })
  )

  return (
    <StyledBreadcrumbsContainer>
      <div className={"breadcrumbs"}>{breadcrumbs}</div>
    </StyledBreadcrumbsContainer>
  )
}
